import Link from "@mui/icons-material/Link";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { FC } from "react";
import { WhatsAppIcon } from "../../../styles/icons/whatsapp";

export const WhatsAppAnalyticsViewToggle: FC<{
  value: "message" | "linked_page";
  onChange: (value: "message" | "linked_page") => void;
  analyticsIdPrefix: string;
}> = ({ value, onChange, analyticsIdPrefix }) => (
  <ToggleButtonGroup
    exclusive
    value={value}
    onChange={(_, nextValue: "message" | "linked_page" | null) => {
      if (nextValue) onChange(nextValue);
    }}
    aria-label="WhatsApp analytics view"
    sx={{
      alignSelf: "flex-start",
      borderRadius: 4,
      backgroundColor: "action.hover",
      "& .MuiToggleButtonGroup-grouped": {
        gap: 1,
        px: 2,
        py: 1,
        border: 0,
        borderRadius: "24px !important",
        textTransform: "none",
        "&.Mui-selected": {
          border: 1,
          borderColor: "primary.main",
          backgroundColor: "background.paper",
        },
      },
    }}
  >
    <ToggleButton data-analytics-id={`${analyticsIdPrefix}-message-toggle`} value="message">
      <WhatsAppIcon fontSize="small" />
      WhatsApp message
    </ToggleButton>
    <ToggleButton data-analytics-id={`${analyticsIdPrefix}-linked-page-toggle`} value="linked_page">
      <Link fontSize="small" />
      Linked page
    </ToggleButton>
  </ToggleButtonGroup>
);
